<template>
  <!-- 单个订单详细 -->
  <div class="contions">
    <!-- <Button>打印</Button> -->
    <div>
      <div class="one">
        <div>
          <p>Invoice To：</p>
          <p>{{$t('Myorder.MemberNo')}}:{{ all.MemberID }}</p>
          <p>{{$t('login.ela')}}：{{ all.EMail }}</p>
          <p>{{$t('Home.contactnumber')}}：{{ all.TelePhone }}</p>
          <!-- <p>
            收货方式：{{(all.ServiceType == 2 ? '送货上门':(all.ServiceType == 3?'自提点自取':'未知'))}}
            收貨方式：{{order}}
        </p> -->
        </div>
        <div>
          <p>{{$t('Personal.Consignee')}}：{{ all.CName }}</p>
          <p>{{$t('Personal.two')}}/{{$t('Personal.Tel')}}: {{ all.CName }} {{ all.Mobile }}</p>
          <p>
            <!-- 收货方式：{{(all.ServiceType == 2 ? '送货上门':(all.ServiceType == 3?'自提点自取':'未知'))}} -->
            {{$t('Myorder.ReceivingMethod')}}：{{ order }}
          </p>
          <!-- <p>支付/收貨方式：{{all.PayType}}</p> -->
          <p>{{$t('Side.Receiving')}}：{{ all.Address }}</p>
        </div>
      </div>
      <div>
        <p>{{$t('BZ')}}： {{ all.OrderMemo}}</p>
      </div>
      <!-- <div v-for="(item,index) in allorder" :key="index">{{item}}</div> -->
      <div class="two">
        <h4>Your Invoice</h4>
        <div class="date">
          <table id="table" cellspacing="0">
            <tr>
              <td style="color:#fff">{{$t('Myorder.SerialNumber')}}</td>
              <td style="color:#fff">{{$t('kdgs')}}</td>
              <!-- <td>集包单号</td> -->
              <td style="color:#fff">{{$t('Forecastpackage.couriernumber')}}</td>
              <td style="color:#fff">{{$t('Home.Good')}}</td>
              <td style="color:#fff">{{$t('Myorder.WarehousingTime')}}</td>
              <td style="color:#fff">{{$t('Forecastpackage.Namegoods')}}</td>
              <td style="color:#fff">{{$t('Mypackage.Totalweight')}}</td>
              <td style="color:#fff">{{$t('sz')}}</td>
              <td style="color:#fff">{{$t('Forecastpackage.Size')}}</td>
              <td style="color:#fff">{{$t('Mypackage.Picture')}}</td>
              <td style="color:#fff">{{$t('BZ')}}</td>
            </tr>
            <tr v-for="(item, index) in allorder.QueryOrderToList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.kdCom }}</td>
              <!-- <td></td> -->
              <td>{{ item.kdBillcode }}</td>
              <td>{{ item.WaveHouse }}</td>
              <td>{{ item.ddTime }}</td>
              <td>{{ item.Goods }}</td>
              <td>{{ item.sFareWeight }}</td>
              <td>{{ item.Weight }}</td>
              <td>{{ item.Size }}</td>
              <td>暫無圖片</td>
              <td>{{ item.Rem }}</td>
            </tr>
            <tr>
              <td>實際重量：</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ all.Weight }}</td>
            </tr>
            <!-- <tr>
              <td>實際重量：</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ all.Weight }}</td>
            </tr> -->
          </table>
          <div class="three">
            <p>Totals：</p>
            <div class="block">
              <p>{{$t('Myorder.PointsDeduction')}}：-RM{{ all.JFFree }}</p>
              <p>{{$t('Myorder.CouponDeduction')}}：-RM{{ all.Jyj_Money }}</p>
              <p>{{$t('Home.Extralongfee')}}：RM{{ all.longFee }}</p>
              <p>{{$t('Myorder.AddressSurcharge')}}：RM{{ all.OrterFree }}</p>
              <p>{{$t('Myorder.WaybillSurcharge')}}：RM0.00</p>
            </div>
            <div class="block">
              <p>{{$t('Myorder.TaxReturn')}}：RM{{ all.Bs_Free }}</p>
              <p>{{$t('Myorder.InsuredValue')}}：RM{{ all.Bj_Money }}</p>
              <p>{{$t('Myorder.InsuranceCommission')}}：RM{{ all.Bj_Sxf }}</p>
              <p>{{$t('Myorder.CollectionGoods')}}：DHS {{ all.Dshk }}</p>
              <p>{{$t('Myorder.GoodsServiceCharge')}}：RM{{ all.Dshk_Sxf }}</p>
            </div>
            <div class="four">
              <div>
                <span>{{$t('Myorder.OrderFreight')}}：</span><span>RM{{ all.Z_Free }}</span>
              </div>
              <div>
                <span>{{$t('Myorder.TotalExpenses')}}：</span><span>RM{{ all.Fare }}</span>
              </div>
              <div>
                <span>{{$t('Myorder.ActualPayment')}}：</span><span>RM{{ all.Fare }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderID: null,
      allorder: [],
      all: {},
      order: "",
    };
  },
  created() {
    this.order = this.$route.query.air_name;
  },
  mounted() {
    this.orderID = this.$route.query.orderID;
    this.QueryOrderDetail();
  },
  methods: {
    async QueryOrderDetail() {
      const params = {
        MemberID: localStorage.getItem("userID"),
        ID: this.orderID,
      };
      const { data } = await this.$post("QueryOrderDetail", params);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
        this.all = JSON.parse(data.ReturnJson).QueryOrderDetail[0];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contions {
  width: 1069px;
  background: #fff;
  // height: 700px;
  padding: 20px 29px;
  .one {
    display: flex;
    flex-direction: row;
    margin: 15px 0 0 0;
    div p {
      line-height: 26px;
      cursor: pointer;
    }
    > div:nth-child(2) {
      margin: 0px 0 0 100px;
    }
  }
  .two {
    margin-top: 20px;
    h4 {
      font-weight: bold;
      font-size: 20px;
    }
    .date {
      margin: 0 0 0 30px;
      #table {
        width: 949px;
        cursor: pointer;
        tr {
          height: 40px;
        }
        tr:nth-child(1) {
          // background: #ccc;
          // background: linear-gradient(0deg, #ff920a 0%, #ffaf4b 100%);
          background: #4141a0;
          font-size: 14px;
          color: #fff !important;
          td {
            color: #000;
            font-size: 14px;
            font-weight: bold;
          }
        }
        td {
          width: 100px;
          font-size: 12px;
          text-align: center;
          border-bottom: 1px solid #ccc;
        }
        .td:nth-child(even) {
          background: #fff;
        }
        .td:nth-child(odd) {
          background: #f1f5fe;
        }
      }
    }
    .three {
      margin: 5px 0 0 0;
      > p {
        font-size: 16px;
        cursor: pointer;
        font-weight: bold;
      }
      .block {
        display: flex;
        flex-direction: row;
        p {
          cursor: pointer;
          margin: 0 20px;
          width: 150px;
          text-align: center;
        }
      }
    }
    .four {
      margin: 10px 0 0 0;
      div:nth-child(1) {
        background: #c3c3c3b8;
      }
      div:nth-child(2) {
        background: #c2c2c2;
      }
      div:nth-child(3) {
        // background: red;
        color: #fff;
         background: #4141a0;
      }
      div {
        width: 949px;
        height: 30px;
        background: #fff;
        span:nth-child(1) {
          float: left;
          line-height: 30px;
          padding: 0 5px;
        }
        span:nth-child(2) {
          float: right;
          line-height: 30px;
          padding: 0 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/Detailedorder.vue